import { useEffect } from "react";

// Hook
/**
 * @see https://usehooks.com/useOnClickOutside/
 */
export default function useOnClickOutside(ref, handler) {
  useEffect(
    () => {
      const listener = (event) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(event.target)) {
          return;
        }

        // Add exception for react-select
        if (event.target.id.match(/react-select/)) {
          return;
        }

        handler(event);
      };
      document.addEventListener("mousedown", listener, true);
      document.addEventListener("touchstart", listener, true);

      return () => {
        document.removeEventListener("mousedown", listener, true);
        document.removeEventListener("touchstart", listener, true);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler],
  );
}
